// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"bc561f54","752":"bc561f54","844":"9a052dc3","875":"5e201da0","946":"1d8cf744"}[chunkId] + ".chunk.css";
};